import { Language } from "types";

export default function formatNumber(number: number, lang: Language) {
  const formattedNumber = number.toLocaleString(lang);
  return formattedNumber;
}
